// extracted by mini-css-extract-plugin
export var buttons = "bh_cG";
export var container = "bh_b";
export var image = "bh_g";
export var p = "bh_fd";
export var section = "bh_d";
export var short = "bh_ff";
export var textContainer = "bh_b1";